import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ } from "../../Utils/Global";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import Combobox from '../Helper/Combobox';
import GeometryGrid from '../Helper/GeometryGrid';
import Grid from '../Helper/Grid';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import Document from './Document';

/**
* Class Evenement
* Evenement view component
**/
class Evenement extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Evenement";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    // Transforms date fields
    let dateEvenement = null;

    if(this.state.object !== undefined) {
      if(this.state.object.dateEvenement) {

        dateEvenement = this.state.object.dateEvenement;

        if(typeof dateEvenement === "string") {
          dateEvenement = getDateFromString(dateEvenement);
        }

        dateEvenement = getIsoStringFromDate(dateEvenement);
      }
    }

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="evenementForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de l'événement.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idEvenement" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idEvenement")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelle">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Libellé</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("libelle")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="dateEvenement">
            <Col componentClass={ControlLabel} sm={2}>Date de l'événement</Col>
            <Col sm={2}><DatePicker dateFormat="DD/MM/YYYY" value={dateEvenement} onChange={this.handleDateEvenementChange.bind(this)} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* TypeEvenement ManyToOne */}
          <FormGroup controlId="idTypeEvenement">
            <Col componentClass={ControlLabel} sm={2}>Type d'événement</Col>
            <Col sm={6}><Combobox url={REST_API_URL + "typeevenements/"} optionValueKey="idTypeEvenement" optionLabelKey="libelle"
              onChange={this.handleTypeEvenementChange.bind(this)} placeholder="Type d'événement" default={this.getObjectProperty("idTypeEvenement")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* EtatEvenement ManyToOne */}
          <FormGroup controlId="idEtatEvenement">
            <Col componentClass={ControlLabel} sm={2}>Etat de l'événement</Col>
            <Col sm={6}><Combobox url={REST_API_URL + "etatevenements/"} optionValueKey="idEtatEvenement" optionLabelKey="libelle"
              onChange={this.handleEtatEvenementChange.bind(this)} placeholder="Etat de l'événement" default={this.getObjectProperty("idEtatEvenement")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="description">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Description</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("description")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Document OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Document.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Documents" path="documents" objectPath={"evenements/" + this.getObjectProperty("idEvenement") + "/documents"} objectClass={Document}
              hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Geom OneToMany */}
          {(this.state.mode !== "add") ?
            <GeometryGrid title="Géométries" path="evenements_geoms" objectPath={"evenements_geoms/" + this.getObjectProperty("idEvenement")} objectClass={Evenement} mode={this.state.mode}
              queryLayers={"EvenementCreate"} allowDraw={false} selectionMultiple={true} typeGeometry="all" withImportCsv={false} withImportPoint={false} /> : null
          }

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" onClick={this.submit.bind(this)}>Sauvegarder</Button>
              </Col>
            </FormGroup>: null
          }
        </Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idEvenement";
  }

  /**
  * submit
  * Saves the data
  **/
  submit () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    let evenementObj = cloneObject(this.state.object);

    if(typeof evenementObj.dateEvenement !== "string") {
      evenementObj.dateEvenement = getStringFromDate(evenementObj.dateEvenement);
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(evenementObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Evénement sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Evénement créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/evenements/" + newObj.idEvenement + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * handleDateEvenementChange
  * Modify the state dateEvenement property from dateEvenement field change
  **/
  handleDateEvenementChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateEvenement"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);
  }

  /**
  * handleTypeEvenementChange
  * Modify the state idTypeEvenement property from idTypeEvenement Combobox change
  **/
  handleTypeEvenementChange(typeEvenement) {
    let objState = this.state;
    objState.object["idTypeEvenement"] = typeEvenement.idTypeEvenement;
    this.setState(objState);
  }

  /**
  * handleEtatEvenementChange
  * Modify the state idEtatEvenement property from idEtatEvenement Combobox change
  **/
  handleEtatEvenementChange(etatEvenement) {
    let objState = this.state;
    objState.object["idEtatEvenement"] = etatEvenement.idEtatEvenement;
    this.setState(objState);
  }

}
export default Evenement;



// WEBPACK FOOTER //
// ./src/views/Entity/Evenement.js